import React from "react";

const Collection = ({ source, items, autocomplete }) => {
  const { header, item: itemTemplate, footer } = source.templates;

  return (
    <div>
      {header && header({ source, autocomplete })}
      {items.length > 0 && (
        <ul {...autocomplete.getListProps()}>
          {items.map((item, index) => (
            <li
              key={item.document.id}
              {...autocomplete.getItemProps({
                item,
                source,
              })}
            >
              {itemTemplate({ item, index })}
            </li>
          ))}
        </ul>
      )}
      {footer && footer({ source, autocomplete })}
    </div>
  );
};

export default Collection;
